/**
 * Enterprise Security Utility Module
 * Provides PII masking, input sanitization, and common regex patterns.
 */
export const REGEX_PATTERNS = {
  EMAIL: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
  PHONE: /(\+?\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g,
  CREDIT_CARD: /\b(?:\d{4}[-\s]?){3}\d{4}\b/g,
  IP_ADDRESS: /\b(?:\d{1,3}\.){3}\d{1,3}\b/g,
  API_KEY: /(?:key|api|token|secret|auth|pwd|password|pass)(?:[\s|'|"]*(?:[:|=]|\b))[\s|'|"]*([a-zA-Z0-9-_{}]{16,})/gi,
};
/**
 * Redacts Personally Identifiable Information (PII) from a string.
 */
export function maskPII(text: string): string {
  if (!text) return text;
  let masked = text;
  // Mask Emails
  masked = masked.replace(REGEX_PATTERNS.EMAIL, "[EMAIL_REDACTED]");
  // Mask Phone Numbers
  masked = masked.replace(REGEX_PATTERNS.PHONE, "[PHONE_REDACTED]");
  // Mask Credit Cards
  masked = masked.replace(REGEX_PATTERNS.CREDIT_CARD, "[CARD_REDACTED]");
  // Mask IP Addresses
  masked = masked.replace(REGEX_PATTERNS.IP_ADDRESS, "[IP_REDACTED]");
  // Mask potential API keys/secrets
  masked = masked.replace(REGEX_PATTERNS.API_KEY, (match, key) => {
    return match.replace(key, "************");
  });
  return masked;
}
/**
 * Basic input sanitization to prevent XSS and common injection characters.
 */
export function sanitizeInput(input: string): string {
  if (!input) return input;
  return input
    .replace(/<script\b[^>]*>([\s\S]*?)<\/script>/gim, "")
    .replace(/[<>]/g, (tag) => {
      const replacements: Record<string, string> = { "<": "&lt;", ">": "&gt;" };
      return replacements[tag] || tag;
    })
    .trim();
}